var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 1127,
    viewBox: "0 0 1512 1127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1951_32233)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1951_32233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514 1030.25C514 1030.25 504.57 1054.32 511.43 1058.47C542.06 1077.01 633.89 1092.28 725.7 1095.68C854.02 1100.43 995.65 1095 1055.43 1071.3C1060.78 1069.18 1067.82 1060.39 1069.55 1054.62C1073.09 1042.79 1066.98 1031.53 1066.98 1031.53C1066.98 1031.53 897.19 1046.92 744.98 1046.92C621.93 1046.92 514 1030.25 514 1030.25Z",
    fill: "url(#paint0_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1512 1127.81H1379.5L946 921.5L683.5 1004L491.5 1127.81H0H637L660.75 1090.81L921 1094L937.5 1127L1512 1127.81Z",
    fill: "url(#paint1_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 1131.81L751 961.81",
    stroke: "#070B36",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996 945.81L1380 1128.81L996 945.81Z",
    fill: "#070B36",
    stroke: "#070B36",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M879 972.81L963 1128.81L879 972.81Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1186.5 1034.77L1291.5 1085.5L1276.5 1092.77L1246.5 1091.77H1012.5L1186.5 1034.77Z",
    fill: "url(#paint2_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695 982L611 1138",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.61 963.53C1020.97 951.61 602.53 969.64 470.38 969.94C424.38 970.05 512.72 1031.53 512.72 1031.53L510.16 1057.19C510.16 1057.19 528.29 1089.34 774.46 1095.68C889.98 1098.68 1003.71 1092.86 1045.18 1076.43C1070.18 1066.54 1070.84 1052.06 1070.84 1052.06L1066.99 1030.25C1066.99 1030.25 1089.99 1017.12 1099.07 1005.87C1114.66 986.63 1119.05 964.65 1110.61 963.53Z",
    fill: "url(#paint3_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.61 963.53C1020.97 951.61 602.53 969.64 470.38 969.94C424.38 970.05 512.72 1031.53 512.72 1031.53L510.16 1057.19C510.16 1057.19 528.29 1089.34 774.46 1095.68C889.98 1098.68 1003.71 1092.86 1045.18 1076.43C1070.18 1066.54 1070.84 1052.06 1070.84 1052.06L1066.99 1030.25C1066.99 1030.25 1089.99 1017.12 1099.07 1005.87C1114.66 986.63 1119.05 964.65 1110.61 963.53Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 1044.81C614.3 1045.02 512 1030.81 512 1030.81C512 1030.81 613.3 1049.02 729 1048.81C883.59 1048.53 1043 1032.81 1043 1032.81C1043 1032.81 884.59 1044.53 730 1044.81Z",
    fill: "#000204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 1044.81C614.3 1045.02 512 1030.81 512 1030.81C512 1030.81 613.3 1049.02 729 1048.81C883.59 1048.53 1043 1032.81 1043 1032.81C1043 1032.81 884.59 1044.53 730 1044.81Z",
    fill: "#070B36",
    stroke: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.049 935.98C637.049 934.86 459.489 953.08 457.619 967.44C454.679 989.99 604.319 993.65 785.289 993.65C966.259 993.65 1105.77 981.31 1112.95 968.75C1125.44 946.93 1056.29 937.45 818.049 935.98Z",
    fill: "url(#paint4_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.049 935.98C637.049 934.86 459.489 953.08 457.619 967.44C454.679 989.99 604.319 993.65 785.289 993.65C966.259 993.65 1105.77 981.31 1112.95 968.75C1125.44 946.93 1056.29 937.45 818.049 935.98Z",
    fill: "url(#paint5_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 971.81C530.493 971.81 539 968.899 539 965.31C539 961.72 530.493 958.81 520 958.81C509.507 958.81 501 961.72 501 965.31C501 968.899 509.507 971.81 520 971.81Z",
    fill: "url(#paint6_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 971.81C530.493 971.81 539 968.899 539 965.31C539 961.72 530.493 958.81 520 958.81C509.507 958.81 501 961.72 501 965.31C501 968.899 509.507 971.81 520 971.81Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632 987.81C642.493 987.81 651 984.899 651 981.31C651 977.72 642.493 974.81 632 974.81C621.507 974.81 613 977.72 613 981.31C613 984.899 621.507 987.81 632 987.81Z",
    fill: "url(#paint7_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632 987.81C642.493 987.81 651 984.899 651 981.31C651 977.72 642.493 974.81 632 974.81C621.507 974.81 613 977.72 613 981.31C613 984.899 621.507 987.81 632 987.81Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972 980.81C982.493 980.81 991 977.899 991 974.31C991 970.72 982.493 967.81 972 967.81C961.507 967.81 953 970.72 953 974.31C953 977.899 961.507 980.81 972 980.81Z",
    fill: "url(#paint8_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972 980.81C982.493 980.81 991 977.899 991 974.31C991 970.72 982.493 967.81 972 967.81C961.507 967.81 953 970.72 953 974.31C953 977.899 961.507 980.81 972 980.81Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850 988.81C860.493 988.81 869 985.899 869 982.31C869 978.72 860.493 975.81 850 975.81C839.507 975.81 831 978.72 831 982.31C831 985.899 839.507 988.81 850 988.81Z",
    fill: "url(#paint9_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850 988.81C860.493 988.81 869 985.899 869 982.31C869 978.72 860.493 975.81 850 975.81C839.507 975.81 831 978.72 831 982.31C831 985.899 839.507 988.81 850 988.81Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746 990.81C756.493 990.81 765 987.899 765 984.31C765 980.72 756.493 977.81 746 977.81C735.507 977.81 727 980.72 727 984.31C727 987.899 735.507 990.81 746 990.81Z",
    fill: "url(#paint10_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746 990.81C756.493 990.81 765 987.899 765 984.31C765 980.72 756.493 977.81 746 977.81C735.507 977.81 727 980.72 727 984.31C727 987.899 735.507 990.81 746 990.81Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058 964.81C1068.49 964.81 1077 961.899 1077 958.31C1077 954.72 1068.49 951.81 1058 951.81C1047.51 951.81 1039 954.72 1039 958.31C1039 961.899 1047.51 964.81 1058 964.81Z",
    fill: "url(#paint11_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058 964.81C1068.49 964.81 1077 961.899 1077 958.31C1077 954.72 1068.49 951.81 1058 951.81C1047.51 951.81 1039 954.72 1039 958.31C1039 961.899 1047.51 964.81 1058 964.81Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.719 854.47L678.229 875C678.229 875 735.229 877.88 793.709 877.57C855.709 877.24 919.439 873.72 919.439 873.72L937.439 854.47H648.719Z",
    fill: "url(#paint12_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.719 854.47L678.229 875C678.229 875 735.229 877.88 793.709 877.57C855.709 877.24 919.439 873.72 919.439 873.72L937.439 854.47H648.719Z",
    fill: "url(#paint13_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.39 912.21C940.129 897.599 932.841 883.451 924.58 869.87L669.25 868.58L633.33 966.09C633.33 966.09 714.89 972.44 797.56 971.23C905.9 969.63 961.78 959.68 961.78 959.68C957.755 943.52 952.612 927.658 946.39 912.21V912.21Z",
    fill: "url(#paint14_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.39 912.21C940.129 897.599 932.841 883.451 924.58 869.87L669.25 868.58L633.33 966.09C633.33 966.09 714.89 972.44 797.56 971.23C905.9 969.63 961.78 959.68 961.78 959.68C957.755 943.52 952.612 927.658 946.39 912.21V912.21Z",
    fill: "url(#paint15_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.88 918.619C711.99 918.619 652.57 913.489 652.57 913.489V914.809C694.718 919.841 737.123 922.412 779.57 922.509C857.4 922.509 946.37 914.809 946.37 914.809V913.529C946.37 913.529 858.38 918.619 780.88 918.619Z",
    fill: "#070B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.88 918.619C711.99 918.619 652.57 913.489 652.57 913.489V914.809C694.718 919.841 737.123 922.412 779.57 922.509C857.4 922.509 946.37 914.809 946.37 914.809V913.529C946.37 913.529 858.38 918.619 780.88 918.619Z",
    fill: "#070B36",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.07 858.32C872.786 858.32 937.409 856.023 937.409 853.19C937.409 850.356 872.786 848.06 793.07 848.06C713.353 848.06 648.729 850.356 648.729 853.19C648.729 856.023 713.353 858.32 793.07 858.32Z",
    fill: "url(#paint16_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.44 857.04C645.44 858.77 640.09 863.45 632.81 869.46C639.65 863.81 628.87 884.35 603.81 901.94C585.92 914.51 565.72 905.3 565.32 927.6C565.23 932.32 556.96 959.599 561.47 963.529C579.47 979.059 635.88 964.81 635.88 964.81C635.88 964.81 651.11 932.53 653.88 914.81C667.88 898.18 678.25 875.04 678.25 875.04C678.25 875.04 653.94 851.32 647.44 857.04Z",
    fill: "url(#paint17_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.44 857.04C645.44 858.77 640.09 863.45 632.81 869.46C639.65 863.81 628.87 884.35 603.81 901.94C585.92 914.51 565.72 905.3 565.32 927.6C565.23 932.32 556.96 959.599 561.47 963.529C579.47 979.059 635.88 964.81 635.88 964.81C635.88 964.81 651.11 932.53 653.88 914.81C667.88 898.18 678.25 875.04 678.25 875.04C678.25 875.04 653.94 851.32 647.44 857.04Z",
    fill: "url(#paint18_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017 910.919C1006.45 902.319 988.58 897.239 974.66 886.549C960.17 875.409 956.31 861.009 938.74 855.749C934.42 854.459 932.74 858.949 929.74 862.169C925.44 866.819 920.74 871.169 920.74 871.169C921.723 875.303 923.462 879.219 925.87 882.719C930.87 890.359 939.63 900.409 945.11 912.229C948.04 918.549 946.73 925.339 948.96 931.469C952.54 941.181 956.828 950.616 961.79 959.699C961.79 959.699 1029.54 958.069 1028.51 955.849C1026.37 951.239 1029.49 921.139 1017 910.919Z",
    fill: "url(#paint19_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017 910.919C1006.45 902.319 988.58 897.239 974.66 886.549C960.17 875.409 956.31 861.009 938.74 855.749C934.42 854.459 932.74 858.949 929.74 862.169C925.44 866.819 920.74 871.169 920.74 871.169C921.723 875.303 923.462 879.219 925.87 882.719C930.87 890.359 939.63 900.409 945.11 912.229C948.04 918.549 946.73 925.339 948.96 931.469C952.54 941.181 956.828 950.616 961.79 959.699C961.79 959.699 1029.54 958.069 1028.51 955.849C1026.37 951.239 1029.49 921.139 1017 910.919Z",
    fill: "url(#paint20_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.689 166.809C586.599 164.609 564.049 202.729 564.049 202.729C564.049 202.729 554.889 222.929 584.569 247.639C593.279 254.889 584.449 266.989 602.569 270.729C635.999 277.609 737.899 243.219 778.309 245.029C853.649 248.419 944.619 273.139 991.309 265.559C1016.41 261.489 1020.82 223.219 1020.82 223.219C1020.82 223.219 1004.17 168.809 802.689 166.809Z",
    fill: "url(#paint21_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.689 166.809C586.599 164.609 564.049 202.729 564.049 202.729C564.049 202.729 554.889 222.929 584.569 247.639C593.279 254.889 584.449 266.989 602.569 270.729C635.999 277.609 737.899 243.219 778.309 245.029C853.649 248.419 944.619 273.139 991.309 265.559C1016.41 261.489 1020.82 223.219 1020.82 223.219C1020.82 223.219 1004.17 168.809 802.689 166.809Z",
    fill: "url(#paint22_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.709 223.22C581.849 218.3 589.709 268.13 589.709 268.13C589.709 268.13 611.539 312.43 805.249 313.03C985.939 313.59 997.709 273.26 997.709 273.26C997.709 273.26 1012.33 228.3 793.709 223.22Z",
    fill: "url(#paint23_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.709 223.22C581.849 218.3 589.709 268.13 589.709 268.13C589.709 268.13 611.539 312.43 805.249 313.03C985.939 313.59 997.709 273.26 997.709 273.26C997.709 273.26 1012.33 228.3 793.709 223.22Z",
    fill: "url(#paint24_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.999 239.899C617.879 240.389 633.319 279.669 633.319 279.669C633.319 279.669 649.559 310.619 787.319 313.029C955.499 315.979 954.119 280.959 954.119 280.959C954.119 280.959 964.999 239.379 785.999 239.899Z",
    fill: "url(#paint25_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.999 239.899C617.879 240.389 633.319 279.669 633.319 279.669C633.319 279.669 649.559 310.619 787.319 313.029C955.499 315.979 954.119 280.959 954.119 280.959C954.119 280.959 964.999 239.379 785.999 239.899Z",
    fill: "url(#paint26_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.999 283.52C939.469 282.83 942.799 251.2 779.619 251.45C641.509 251.66 646.189 283.52 646.189 283.52L667.999 311.75C667.999 311.75 815.999 327.95 896.379 319.45C933.629 315.51 941.569 285.59 939.999 283.52Z",
    fill: "url(#paint27_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.999 283.52C939.469 282.83 942.799 251.2 779.619 251.45C641.509 251.66 646.189 283.52 646.189 283.52L667.999 311.75C667.999 311.75 815.999 327.95 896.379 319.45C933.629 315.51 941.569 285.59 939.999 283.52Z",
    fill: "url(#paint28_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.56 333.56C920.56 288.75 654.72 292.69 656.42 328.43C658.12 364.17 941.5 372.13 933.56 333.56Z",
    fill: "url(#paint29_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.56 333.56C920.56 288.75 654.72 292.69 656.42 328.43C658.12 364.17 941.5 372.13 933.56 333.56Z",
    fill: "url(#paint30_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.709 333.56L920.559 334.17C920.559 334.17 901.719 420.17 905.329 419.52C905.999 419.41 930.999 405.41 930.999 405.41L929.709 333.56Z",
    fill: "url(#paint31_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.709 333.56L920.559 334.17C920.559 334.17 901.719 420.17 905.329 419.52C905.999 419.41 930.999 405.41 930.999 405.41L929.709 333.56Z",
    fill: "url(#paint32_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.559 320.73C933.559 319.73 921.459 288.68 783.439 291.22C666.099 293.39 656.439 316.88 656.439 316.88V329.71C656.439 329.71 893.659 337.22 931.009 333.56C934.219 333.25 933.559 321.03 933.559 320.73Z",
    fill: "url(#paint33_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.559 320.73C933.559 319.73 921.459 288.68 783.439 291.22C666.099 293.39 656.439 316.88 656.439 316.88V329.71C656.439 329.71 893.659 337.22 931.009 333.56C934.219 333.25 933.559 321.03 933.559 320.73Z",
    fill: "url(#paint34_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.729 311.75C852.729 311.24 817.909 306.16 803.969 305.34L796.27 307.9V328.43C796.27 328.43 798.49 330.43 798.84 334.84C799.74 346.23 802.69 368.2 802.69 368.2L828.299 381.7L848.88 369.49C848.88 369.49 845.099 334.15 852.729 331C856.249 329.54 852.729 312.72 852.729 311.75Z",
    fill: "url(#paint35_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.729 311.75C852.729 311.24 817.909 306.16 803.969 305.34L796.27 307.9V328.43C796.27 328.43 798.49 330.43 798.84 334.84C799.74 346.23 802.69 368.2 802.69 368.2L828.299 381.7L848.88 369.49C848.88 369.49 845.099 334.15 852.729 331C856.249 329.54 852.729 312.72 852.729 311.75Z",
    fill: "url(#paint36_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.8 331V345.11L682.08 381.03L675.67 397.71L688.5 399L696.2 381L697.48 345.08V331C697.48 329.97 680.8 331 680.8 331Z",
    fill: "url(#paint37_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.8 331V345.11L682.08 381.03L675.67 397.71L688.5 399L696.2 381L697.48 345.08V331C697.48 329.97 680.8 331 680.8 331Z",
    fill: "url(#paint38_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.269 307.9L809.099 302.77L803.969 305.33V325.86L809.099 328.43L811.669 361.79L828.349 381.03L860.419 364.35V331L865.559 324.58L864.269 307.9Z",
    fill: "url(#paint39_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.269 307.9L809.099 302.77L803.969 305.33V325.86L809.099 328.43L811.669 361.79L828.349 381.03L860.419 364.35V331L865.559 324.58L864.269 307.9Z",
    fill: "url(#paint40_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.329 334.839L904.049 409.259V415.679L920.729 403.309V334.329L905.329 334.839Z",
    fill: "url(#paint41_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.329 334.839L904.049 409.259V415.679L920.729 403.309V334.329L905.329 334.839Z",
    fill: "url(#paint42_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.69 329.709C665.63 328.649 666.69 388.709 666.69 388.709L675.69 397.709C679.832 393.021 682.509 387.222 683.39 381.029C685.56 362.439 685.95 331.029 685.95 331.029C685.95 331.029 667.08 330.109 666.69 329.709Z",
    fill: "url(#paint43_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.69 329.709C665.63 328.649 666.69 388.709 666.69 388.709L675.69 397.709C679.832 393.021 682.509 387.222 683.39 381.029C685.56 362.439 685.95 331.029 685.95 331.029C685.95 331.029 667.08 330.109 666.69 329.709Z",
    fill: "url(#paint44_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.229 817.26L669.229 804.43C669.229 804.43 659.769 816.57 660.229 817.26C660.689 817.95 658.659 855.58 660.229 855.75C662.139 855.96 675.309 860.88 678.229 854.47C683.359 843.1 678.229 817.26 678.229 817.26Z",
    fill: "url(#paint45_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.229 817.26L669.229 804.43C669.229 804.43 659.769 816.57 660.229 817.26C660.689 817.95 658.659 855.58 660.229 855.75C662.139 855.96 675.309 860.88 678.229 854.47C683.359 843.1 678.229 817.26 678.229 817.26Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.229 817.26V855.75L694.909 854.47V817.26H678.229Z",
    fill: "url(#paint46_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.229 817.26V855.75L694.909 854.47V817.26H678.229Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.219 804.43H669.219C669.219 804.43 676.119 821.11 678.219 821.11C681.329 821.11 693.319 824.61 694.899 819.83C695.999 816.56 687.219 804.43 687.219 804.43Z",
    fill: "url(#paint47_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.219 804.43H669.219C669.219 804.43 676.119 821.11 678.219 821.11C681.329 821.11 693.319 824.61 694.899 819.83C695.999 816.56 687.219 804.43 687.219 804.43Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.439 804.43H904.049L905.329 855.75H920.729L919.439 804.43Z",
    fill: "url(#paint48_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.439 804.43H904.049L905.329 855.75H920.729L919.439 804.43Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M565.33 225.81L804 192.43L565.33 225.81Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M821.929 273.259C821.929 273.259 761.399 273.259 712.929 278.389C692.447 280.638 672.243 284.936 652.619 291.219C672.824 284.919 693.585 280.566 714.619 278.219C762.899 273.109 821.929 273.259 821.929 273.259Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M711.589 278.39L706.459 255.3L711.589 278.39Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.519 318.739L838.609 319.449M821.5 345.5L859.59 346.21",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M800.12 813.41C800.12 813.41 812.12 800.58 824.5 800.58C835.84 800.58 847.59 813.41 847.59 813.41V849.34C847.59 849.34 854.33 855.34 851.44 855.75C840.53 857.43 805.04 855.75 796.27 855.75C794.02 855.75 800.12 849.34 800.12 849.34V813.41Z",
    fill: "url(#paint49_linear_1951_32233)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.07 330.31L675.67 397.71",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839 306V329",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 252V291M804.5 168V193M679.5 210V227",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822 318V374",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M824.5 856.75L821.93 800.3L824.5 856.75Z",
    fill: "#070B36",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M809 909.81L808.93 869.3L809 909.81Z",
    fill: "#070B36",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M823 830L847 829L823 830Z",
    fill: "#070B36",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914.31 844.36L911.75 804.58L914.31 844.36Z",
    fill: "#070B36",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M669.999 842.81L668.719 805.6L669.999 842.81Z",
    fill: "#070B36",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.76 969.939L833.48 949.409",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860 949L859.5 935L859 921",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799 951L798.5 937L798 923",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M797.559 937.869L648.719 931.449L797.559 937.869Z",
    fill: "#070B36",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.56 898.869L809 899.809",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859 949L798 950",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 405,
    fill: "url(#paint50_linear_1951_32233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661 1045V1090L637 1127.5L618 1126.5L661 1045Z",
    fill: "#061833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.5 1041L920.5 1094.5L938.5 1129H963L913.5 1041Z",
    fill: "#061833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638 1088L659.119 1046.53",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.881 1083.47L618 1042",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.5 1089.5L660 1044.04",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921 1094L916.001 1042.04",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.08 1042.3L943.883 1093",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969 1038.47L1001.18 1096.33",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 999.976,
    y1: 1096,
    x2: 1292.98,
    y2: 1089,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.5 1089L920.5 1094L933.5 1117L647 1111L661.5 1089Z",
    fill: "url(#paint51_linear_1951_32233)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1951_32233",
    x1: 789.8,
    y1: 1097.25,
    x2: 789.8,
    y2: 1030.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000912",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000912"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1951_32233",
    x1: -920.389,
    y1: 635.257,
    x2: 1779.4,
    y2: 230.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4254B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#081743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#001E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1951_32233",
    x1: 1012.5,
    y1: 1056.27,
    x2: 1363.5,
    y2: 1056.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#010E1E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1951_32233",
    x1: 457.1,
    y1: 1027.94,
    x2: 1114.84,
    y2: 1027.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#293869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1F51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1951_32233",
    x1: 459.909,
    y1: 995.02,
    x2: 1112.09,
    y2: 937.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1951_32233",
    x1: 459.909,
    y1: 995.02,
    x2: 1112.09,
    y2: 937.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1951_32233",
    x1: 501.14,
    y1: 966.96,
    x2: 538.86,
    y2: 963.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1951_32233",
    x1: 613,
    y1: 981.31,
    x2: 651,
    y2: 981.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1951_32233",
    x1: 953,
    y1: 974.31,
    x2: 991,
    y2: 974.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1951_32233",
    x1: 831,
    y1: 982.31,
    x2: 869,
    y2: 982.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1951_32233",
    x1: 727,
    y1: 984.31,
    x2: 765,
    y2: 984.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1951_32233",
    x1: 1039,
    y1: 958.31,
    x2: 1077,
    y2: 958.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1951_32233",
    x1: 627.871,
    y1: 870.862,
    x2: 654.794,
    y2: 781.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1951_32233",
    x1: 627.871,
    y1: 870.862,
    x2: 654.794,
    y2: 781.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1951_32233",
    x1: 609.613,
    y1: 941.459,
    x2: 823.219,
    y2: 760.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1951_32233",
    x1: 609.613,
    y1: 941.459,
    x2: 823.219,
    y2: 760.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1951_32233",
    x1: 648.719,
    y1: 853.19,
    x2: 937.409,
    y2: 853.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08112B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08112B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1951_32233",
    x1: 619.18,
    y1: 970.78,
    x2: 619.18,
    y2: 856.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#172C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081649"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1951_32233",
    x1: 619.18,
    y1: 970.78,
    x2: 619.18,
    y2: 856.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#172C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081649"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1951_32233",
    x1: 916.75,
    y1: 903.559,
    x2: 1033.18,
    y2: 917.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#041224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09214A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1951_32233",
    x1: 916.75,
    y1: 903.559,
    x2: 1033.18,
    y2: 917.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#041224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09214A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1951_32233",
    x1: 529.636,
    y1: 241.099,
    x2: 748.2,
    y2: -12.3171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1951_32233",
    x1: 529.636,
    y1: 241.099,
    x2: 748.2,
    y2: -12.3171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1951_32233",
    x1: 560.193,
    y1: 286.792,
    x2: 746.877,
    y2: 62.3096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1951_32233",
    x1: 560.193,
    y1: 286.792,
    x2: 746.877,
    y2: 62.3096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1951_32233",
    x1: 609.747,
    y1: 291.866,
    x2: 762.375,
    y2: 114.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1951_32233",
    x1: 609.747,
    y1: 291.866,
    x2: 762.375,
    y2: 114.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1951_32233",
    x1: 624.94,
    y1: 301.404,
    x2: 772.563,
    y2: 137.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1951_32233",
    x1: 624.94,
    y1: 301.404,
    x2: 772.563,
    y2: 137.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1951_32233",
    x1: 666.27,
    y1: 365.79,
    x2: 923.71,
    y2: 296.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#051670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07133E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1951_32233",
    x1: 666.27,
    y1: 365.79,
    x2: 923.71,
    y2: 296.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#051670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07133E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1951_32233",
    x1: 902.982,
    y1: 394.5,
    x2: 932.019,
    y2: 392.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1951_32233",
    x1: 902.982,
    y1: 394.5,
    x2: 932.019,
    y2: 392.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1951_32233",
    x1: 636.425,
    y1: 321.905,
    x2: 716.656,
    y2: 186.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1951_32233",
    x1: 636.425,
    y1: 321.905,
    x2: 716.656,
    y2: 186.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1951_32233",
    x1: 792.08,
    y1: 359.472,
    x2: 854.441,
    y2: 346.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1951_32233",
    x1: 792.08,
    y1: 359.472,
    x2: 854.441,
    y2: 346.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1951_32233",
    x1: 674.095,
    y1: 379.073,
    x2: 698.316,
    y2: 377.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1951_32233",
    x1: 674.095,
    y1: 379.073,
    x2: 698.316,
    y2: 377.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1951_32233",
    x1: 799.521,
    y1: 358.249,
    x2: 865.527,
    y2: 344.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1951_32233",
    x1: 799.521,
    y1: 358.249,
    x2: 865.527,
    y2: 344.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1951_32233",
    x1: 902.844,
    y1: 391.999,
    x2: 921.446,
    y2: 390.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1951_32233",
    x1: 902.844,
    y1: 391.999,
    x2: 921.446,
    y2: 390.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1951_32233",
    x1: 664.794,
    y1: 377.911,
    x2: 686.733,
    y2: 376.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1951_32233",
    x1: 664.794,
    y1: 377.911,
    x2: 686.733,
    y2: 376.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1951_32233",
    x1: 659.669,
    y1: 831.09,
    x2: 680.509,
    y2: 831.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1951_32233",
    x1: 678.229,
    y1: 836.51,
    x2: 694.909,
    y2: 836.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1951_32233",
    x1: 669.249,
    y1: 813.39,
    x2: 695.009,
    y2: 813.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1951_32233",
    x1: 904.049,
    y1: 830.09,
    x2: 920.729,
    y2: 830.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1951_32233",
    x1: 791.7,
    y1: 840.22,
    x2: 850.55,
    y2: 824.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1951_32233",
    x1: 756,
    y1: 0,
    x2: 756,
    y2: 405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#011122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021325",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1951_32233",
    x1: 788.5,
    y1: 1091,
    x2: 788.5,
    y2: 1111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D1B38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1951_32233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 1127,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1951_32233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1550.11,
    height: 1138.68,
    fill: "white",
    transform: "translate(-16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverLight);
export default __webpack_public_path__ + "static/media/over-light.4e9e207b09af83e7a486a69d0c75fdc8.svg";
export { ForwardRef as ReactComponent };